'use strict';

module.exports = require('./node/');



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/index.js
// module id = 227
// module chunks = 0